export default "__VITE_ASSET__5807bd28__"